export default "__VITE_ASSET__CkYPTjlZ__"